export const ROUTE_HOME = '/'
export const ROUTE_INTRODUCTION = '/introduction'
export const ROUTE_PERFORMANCES = '/performances'
export const ROUTE_MEDIA = '/media'
export const ROUTE_MEDIA_ENREGISTREMENTS = '/media/records'
export const ROUTE_MEDIA_PHOTOS = '/media/albums'
export const ROUTE_MEDIA_VIDEOS = '/media/videos'
export const ROUTE_FRIENDS = '/friends'
export const ROUTE_HIRING = '/hiring'
export const ROUTE_CONTACT = '/contact'



/** WEBPACK FOOTER **
 ** ./src/constants/routes.constants.js
 **/